import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import District from '../entities/city'

import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'

interface DistrictState extends ListState<District>{
    city:District

}

class DistrictMutations extends ListMutations<District>{

}

class DistrictModule extends ListModule<DistrictState,any,District>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<District>(),
        loading:false,
        editDistrict:new District(),
    
    }
    actions={

        async getDistrict(context:ActionContext<DistrictState,any>,payload:any){

            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Definition/GetDistricts?input='+payload.data);

            context.state.loading=false;
            let page=reponse.data.result as PageResult<District>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;

          
        },
 
    };
    mutations={
        setCurrentPage(state:DistrictState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:DistrictState,pagesize:number){
            state.pageSize=pagesize;
        },
       
    }
}
const districtModule=new DistrictModule();
export default districtModule;